module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "side-nav",
    class: {
      'hide': !_vm.sidebar.opened
    }
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.$route.path
    },
    on: {
      "open": _vm.handleOpen,
      "close": _vm.handleClose
    }
  }, [_vm._l((_vm.menus), function(router) {
    return (router.type == 2) ? _c('el-menu-item', {
      key: router.rule_id,
      attrs: {
        "index": ("/" + (router.name))
      }
    }, [_c('i', {
      staticClass: "el-icon-menu"
    }), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": ("/" + (router.name))
      }
    }, [_vm._v(_vm._s(router.title))])], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.menus), function(router) {
    return (router.type == 3) ? _c('el-submenu', {
      key: router.rule_id,
      attrs: {
        "index": router.title
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      staticClass: "el-icon-menu"
    }), _vm._v("\n                " + _vm._s(router.title) + "\n            ")]), _vm._v(" "), _vm._l((router.children), function(child) {
      return _c('el-menu-item', {
        key: child.rule_id,
        attrs: {
          "index": ("/" + (child.name))
        }
      }, [_c('router-link', {
        attrs: {
          "to": ("/" + (child.name) + "/" + (child.rule_id))
        }
      }, [_vm._v(_vm._s(child.title))])], 1)
    })], 2) : _vm._e()
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4755fedb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/components/SideNav.vue
// module id = 869
// module chunks = 0